import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { ILinkURLText } from '@patient-ui/shared/models';

@Component({
  selector: 'ui-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbComponent {
  @Input() links!: ILinkURLText[];
  @Output() handleClick: EventEmitter<void> = new EventEmitter();

  onClick() {
    this.handleClick.emit();
  }
}
